import {
  Bell,
  Bot,
  Building2,
  CalendarCheck,
  ClipboardList,
  Clock,
  Code,
  Cookie,
  History,
  Layers,
  Layout,
  Loader,
  Mail,
  Map,
  MessageSquarePlus,
  Moon,
  NotebookPen,
  PanelLeft,
  PieChart,
  Share2,
  ShieldCheck,
  ShoppingCart,
  Smartphone,
  Sparkles,
  TreePine,
  User,
  UserX,
  type LucideIcon,
} from 'lucide-react';

export const changelogIcons = {
  Bell,
  Bot,
  Building2,
  CalendarCheck,
  ClipboardList,
  Clock,
  Code,
  Cookie,
  History,
  Layers,
  Layout,
  Loader,
  Mail,
  Map,
  MessageSquarePlus,
  Mobile: Smartphone,
  Moon,
  NotebookPen,
  PanelLeft,
  PieChart,
  Share2,
  ShieldCheck,
  ShoppingCart,
  Sparkles,
  TreePine,
  User,
  UserX,
} satisfies Record<string, LucideIcon>;

export type ChangelogIconName = keyof typeof changelogIcons;
